module.exports = __webpack_public_path__ + "img/banner100kata2021-sil-min.ca56dc98.jpg";